import React, { Fragment } from "react";
import { connect } from "formik";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import _ from "lodash";
import { loanTypeList } from "constants/loanTypes";
import interestRateTypeIds, { interestRateTypeList } from "constants/interestRateTypes";

import { SectionGrid, StyledAutoCompleteInput, StyledTextInput, StyledPercentInput, StyledDecimalInput } from "../styles";

import FormSectionTitle from "./FormSectionTitle";

const LoanAssumptionsSection = props => {
  const { formik, interestRateTypes, floatingIndices, fixedIndices } = props;
  const { values, handleChange, form, setFieldTouched } = formik;
  if (!interestRateTypes) {
    return null;
  }

  const loanTypeListFiltered = loanTypeList.filter(x => x.isAssumptionType);

  return (
    <>
      <SectionGrid container item xs={12} alignItems="center" justify="flex-start" spacing={8}>
        <Grid item xs={2} md={2} lg={2}>
          <StyledAutoCompleteInput
            label="Loan Type"
            fieldName="loanType"
            selectValue="value"
            options={loanTypeListFiltered}
            onChange={e => {
              props.setLoanProceedAssumptions(e, props.formik); setFieldTouched("loanType", true);
            }}
          />
        </Grid>

        <Grid item xs={2} md={2} lg={2}><StyledTextInput label="Term(m)" fieldName="loanTerm" /></Grid>
        <Grid item xs={2} md={2} lg={2}><StyledTextInput label="Amort Term(m)" fieldName="amortizationTerm" /></Grid>

      </SectionGrid>
      <SectionGrid container item xs={12} alignItems="center" justify="flex-start" spacing={8}>

        <Grid item xs={2} md={2} lg={2}>
          <StyledPercentInput label="Loan Spread" decimalScale={3} fieldName="spread" />
          {" "}
        </Grid>
        <Grid item xs={2} md={2} lg={2}>
          <StyledAutoCompleteInput label="Interest Rate Type" fieldName="interestRateType" selectValue="value" options={interestRateTypes} />
          {" "}
        </Grid>
        {values.interestRateType && values.interestRateType === interestRateTypeIds.FLOATING &&
          <Grid item xs={2} md={2} lg={2}><StyledAutoCompleteInput label="Rate Index" fieldName="rateIndex" selectValue="value" options={floatingIndices} /></Grid>}

        {values.interestRateType && values.interestRateType === interestRateTypeIds.FIXED &&
          <Grid item xs={2} md={2} lg={2}><StyledAutoCompleteInput label="Rate Index" fieldName="rateIndex" selectValue="value" options={fixedIndices} /></Grid>}

        {values.interestRateType === interestRateTypeIds.FLOATING && <Grid item xs={2} md={2} lg={2}>
          <StyledPercentInput label="Underwr. Rate (Floating)" decimalScale={3} fieldName="UwRate" />
          {" "}
                                                                     </Grid>}

        {/* <Grid item xs={2} md={2} lg={2}><StyledPercentInput label="Index Rate" decimalScale={3} fieldName="treasuryRate" onChange={e => {handleChange(e); const spread = parseFloat(values.spread) ;
                                const treasuryRate = parseFloat(e.target.value); const updated = treasuryRate + spread; const allInRate = {target:{name: "allInRate", value:updated }}
                                handleChange(allInRate); }}/></Grid> */}

      </SectionGrid>
      <SectionGrid container item xs={12} alignItems="center" justify="flex-start" spacing={8}>
        <Grid item xs={2} md={2} lg={2}>
          <StyledDecimalInput label="DSCR" decimalScale={3} fieldName="dscr" />
          {" "}
        </Grid>
        <Grid item xs={2} md={2} lg={2}>
          <StyledPercentInput label="Max LTV" decimalScale={3} fieldName="maxLTV" />
          {" "}
        </Grid>
        <Grid item xs={2} md={2} lg={2}>
          <StyledPercentInput label="Debt Yield" decimalScale={3} fieldName="debtYield" />
          {" "}
        </Grid>
      </SectionGrid>
    </>
  );
};
export default compose(
  connect
)(LoanAssumptionsSection);
